import { getByDomain } from '@/config/sites';

function siteUrl() {
  const ThemeDetection = getByDomain();
  if (ThemeDetection && ThemeDetection.site) {
    return ThemeDetection.site;
  }
  return 'https://www.jobnet.ag';
}

const site = siteUrl();

export const navigation = [
  {
    title: 'Jobnet.AG',
    url: `${site}/JobnetAG/`,
    child: [
      {
        title: 'Profil',
        url: `${site}/JobnetAG/`,
      },
      {
        title: 'Aufsichtsrat',
        url: `${site}/JobnetAG/Aufsichtsrat.php`,
      },
      {
        title: 'Vorstand',
        url: `${site}/JobnetAG/Vorstand.php`,
      },
      {
        title: 'Team',
        url: `${site}/JobnetAG/Team/`,
      },
      {
        title: 'Standorte',
        url: `${site}/JobnetAG/Standorte/`,
      },
      {
        title: 'Netzwerk',
        url: `${site}/Netzwerk/`,
      },
      {
        title: 'Newsletter',
        url: `${site}/JobnetAG/Newsletter/`,
      },
      {
        title: 'Kontakt',
        url: `${site}/JobnetAG/Kontakt/`,
        child: [
          {
            title: 'So erreichen Sie uns',
            url: `${site}/JobnetAG/Kontakt/`,
          },
          {
            title: 'Impressum',
            url: `${site}/JobnetAG/Kontakt/impressum.php`,
          },
          {
            title: 'Support & Webinare',
            url: `${site}/JobnetAG/Kontakt/Support-Webinare.php`,
          },
          {
            title: 'Datenschutz',
            url: `${site}/JobnetAG/datenschutz.php`,
          },
        ],
      },
      {
        title: 'Karriere',
        url: `${site}/JobnetAG/Karriere/`,
      },
    ],
  },
  {
    title: 'Solutions',
    url: `${site}/Solutions/?nav=1`,
    child: [
      {
        title: 'Plattformen für Arbeit, Personal und Bildung',
        url: `${site}/Solutions/Plattformen/`,
        description: 'Schneller und besser in neue Beschäftigung vermitteln',
        child: [
          {
            title: 'JobZENTRALE',
            url: `${site}/Solutions/Plattformen/JobZENTRALE/?nav=0`,
            child: [
              {
                title: 'Übersicht',
                url: `${site}/Solutions/Plattformen/JobZENTRALE/JobZENTRALE.php?nav=produkt`,
              },
              {
                title: 'JobZENTRALE mit den Job-PDF',
                url: `${site}/Solutions/Plattformen/JobZENTRALE/?nav=produkt`,
              },
              {
                title: 'Durchblick statt Suchmaschine',
                url: `${site}/Solutions/Plattformen/JobZENTRALE/Durchblick-statt-Suchmaschine.php`,
              },
              {
                title: 'Wer nutzt die JobZENTRALE?',
                url: `${site}/Solutions/Plattformen/JobZENTRALE/JobZENTRALE_Nutzer.php`,
              },
              {
                title: 'Per Landkarte zur neuen Stelle',
                url: `${site}/Solutions/Plattformen/JobZENTRALE/JobZENTRALE-mit-jobMAPS.php`,
              },
              {
                title: 'Beispiele JobZENTRALE live',
                url: `${site}/Solutions/Plattformen/JobZENTRALE/Beispiel-JobZENTRALE.php?nav=produkt`,
              },
            ],
          },
          {
            title: 'Job Talent Space',
            url: `${site}/Solutions/Plattformen/Job-Talent-Space/`,
            child: [
              {
                title: 'Regionale Portale',
                url: `${site}/Solutions/Regionale-Portale/`,
              },
              {
                title: 'Fachkräfteportal neu',
                url: `${site}/Solutions/Plattformen/Job-Talent-Space/`,
              },
            ],
          },
          {
            title: 'Maßnahmen-Management',
            url: `${site}/Solutions/Plattformen/Massnahmen-Management/`,
          },
        ],
      },
      {
        title: 'Potenzialdiagnostik, Erwerbsfähigkeit, Eignungsdiagnostik',
        url: `${site}/Solutions/Diagnostik/`,
        description: 'Talente, Stärken und Handlungsbedarfe erkennen, neue Impulse setzen',
        child: [
          {
            title: 'ZukunftsProfil',
            url: `${site}/Solutions/Diagnostik/ZukunftsProfil/`,
          },
          {
            title: 'JobIMPULS Methode',
            url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/?nav=produkt`,
            child: [
              {
                title: 'Übersicht',
                url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/?nav=produkt`,
              },
              {
                title: 'Einsatzmöglichkeiten',
                url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/`,
                child: [
                  {
                    title: 'Jobnet Videoberatung',
                    url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-Videoberatung.php`,
                  },
                  {
                    title: 'Jobnet kompakt',
                    url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-kompakt.php?c=de`,
                  },
                  {
                    title: 'Jobnet Potenzialscreening',
                    url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-Potenzialscreening.php?c=de`,
                  },
                  {
                    title: 'Jobnet CuraSkill',
                    url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-CuraSkill.php`,
                  },
                  {
                    title: 'Jobnet LevelUp',
                    url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-LevelUp.php`,
                  },
                  {
                    title: 'Jobnet Sofortangebot',
                    url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-Sofortangebot.php?nav=produkt`,
                  },
                  {
                    title: 'Jobnet BasisCheck',
                    url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-BasisCheck.php?c=de`,
                  },
                  {
                    title: 'Jobnet BerufsWahl',
                    url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-BerufsWahl.php`,
                  },
                  {
                    title: 'Jobnet InterView',
                    url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-InterView.php`,
                  },
                ],
              },
              {
                title: 'Anwendungsfelder',
                url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/JobIMPULS-Methode-Anwendungen.php?nav=produkt`,
              },
              {
                title: 'Wissenschaft',
                url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/JobIMPULS-Methode-wissenschaftliche-Grundlagen.php?nav=produkt`,
              },
              {
                title: 'Datenschutz',
                url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/Jobnet-Datenschutz.php`,
              },
              {
                title: 'Standorte',
                url: `${site}/Solutions/Diagnostik/JobIMPULS-Methode/JobIMPULS-Methode-Standorte.php?nav=produkt`,
              },
            ],
          },
          {
            title: 'padaCura',
            url: `${site}/Solutions/Diagnostik/padaCura/`,
          },
          {
            title: 'CuraSkill',
            url: `${site}/Solutions/Diagnostik/CuraSkill/`,
          },
        ],
      },
      {
        title: 'Lernplattformen',
        url: `${site}/Solutions/Lernplattformen/?nav=produkt`,
        description: 'Modernes Lernen unterstützen, Kosten sparen - auch berufsbegleitend',
        child: [
          {
            title: 'Übersicht',
            url: `${site}/Solutions/Lernplattformen/?nav=produkt`,
          },
          {
            title: 'Deutsch lernen',
            url: `${site}/Solutions/Lernplattformen/Deutsch-lernen/`,
          },
          {
            title: 'Jobnet.LIVE',
            url: `${site}/Solutions/Lernplattformen/Jobnet-LIVE/`,
          },
          {
            title: 'AZAV-Maßnahmen',
            url: `${site}/Solutions/Lernplattformen/AZAV/`,
          },
        ],
      },
      {
        title: 'Community-Lösungen',
        url: `${site}/Solutions/Community/?nav=2`,
        description: 'Gemeinschaft fördern, Isolation überwinden, Lösungspartner vernetzen',
      },
      {
        title: 'Business Intelligence, Integration und Kommunikation',
        url: `${site}/Solutions/Business-Intelligence/`,
        description: 'Arbeitsmarktintegration wirksam steuern, Prozesse optimieren',
        child: [
          {
            title: 'Business Intelligence',
            url: `${site}/Solutions/Business-Intelligence/`,
          },
          {
            title: 'Statistik und Auswertungen',
            url: `${site}/Solutions/Business-Intelligence/Statistik-und-Auswertungen/`,
          },
        ],
      },
      {
        title: 'Künstliche Intelligenz: Jobtalent.AI',
        url: `${site}/Solutions/Artificial-Intelligence/`,
        description: 'Skill-Analyse, Skill-Matching, Bewerbungsassistent, Such- und Formulierungshilfen, agentische KI',
      },
    ],
  },
  {
    title: 'Consulting',
    url: `${site}/Consulting/`,
    child: [
      {
        title: 'Beratung und Projektmanagement',
        url: `${site}/Consulting/?nav=0`,
        description: 'Organisationsberatung, IT-Beratung, Projektmanagement: Akzeptanz und Nutzen sichern',
      },
      {
        title: 'Training und Coaching: Jobnet.Academy',
        url: `${site}/Consulting/Jobnet.Academy/?nav=0`,
        description: 'Anwendungs- und Beratungssicherheit erreichen, Einsatz optimieren',
      },
      {
        title: 'Partnermanagement, Administration und Support',
        url: `${site}/Consulting/Partnermanagement/?nav=0`,
        description: 'Proaktive Unterstützung, Impulse für kontinuierliche Verbesserungen',
      },
    ],
  },
  {
    title: 'Services',
    url: `${site}/Services/`,
    // child: [
    //   {
    //     title: 'Training und Coaching: Jobnet.Academy',
    //     url: `${site}/Services/Jobnet.Academy/?nav=0`,
    //     description: 'Anwendungs- und Beratungssicherheit erreichen, Einsatz optimieren',
    //   },
    //   {
    //     title: 'Partnermanagement, Administration und Support',
    //     url: `${site}/Services/Partnermanagement/?nav=0`,
    //     description: 'Proaktive Unterstützung, Impulse für kontinuierliche Verbesserungen',
    //   },
    // ],
  },
  {
    title: 'International',
    url: `${site}/International/`,
    child: [
      {
        title: 'Österreich',
        url: `${site}/International/Oesterreich/`,
        child: [
          {
            title: 'Übersicht',
            url: `${site}/International/Oesterreich/`,
          },
          {
            title: 'Aktuelles aus Österreich',
            url: `${site}/International/Oesterreich/Aktuelles-aus-Oesterreich/`,
          },
          {
            title: 'JobIMPULS Methode Standorte',
            url: `${site}/International/Oesterreich/Standorte/?we_anchor=tab2#tab2`,
          },
          {
            title: 'Referenzen',
            url: `${site}/International/Oesterreich/Referenzen/?we_anchor=at#at`,
          },
          {
            title: 'Unser Team',
            url: `${site}/International/Oesterreich/Unser-Team/`,
          },
          {
            title: 'Kundenstimmen',
            url: `${site}/International/Oesterreich/Kundenstimmen/?catid=54`,
          },
        ],
      },
      {
        title: 'Philippinen',
        url: `${site}/International/Philippinen/`,
      },
      {
        title: 'Ukraine',
        url: `${site}/International/Ukraine/`,
      },
    ],
  },
  {
    title: 'Kunden',
    url: `${site}/Kunden/`,
    child: [
      {
        title: 'Jobcenter',
        url: `${site}/Kunden/jobcenter/`,
      },
      {
        title: 'Bildungsträger',
        url: `${site}/Kunden/bildungstraeger/`,
      },
      {
        title: 'Berufliche Reha',
        url: `${site}/Kunden/berufliche-rehabilitation/`,
      },
      {
        title: 'Transfergesellschaften',
        url: `${site}/Kunden/transfergesellschaften/`,
      },
      {
        title: 'Wirtschaft+Fachkräfte',
        url: `${site}/Kunden/Wirtschaft-Fachkraefte/`,
      },
      {
        title: 'Referenzen',
        url: `${site}/Kunden/Referenzen/`,
      },
      {
        title: 'Kundenstimmen',
        url: `${site}/Kunden/Kundenstimmen/`,
      },
    ],
  },
  {
    title: 'News',
    url: `${site}/News/?news`,
    child: [
      {
        title: 'Aktuelles von der Jobnet.AG',
        url: `${site}/News/?news`,
      },
      {
        title: 'Die Jobnet.AG in der Presse',
        url: `${site}/News/Presse/`,
      },
    ],
  },
];
